import React from 'react';

import { placeHolderRatio2X3 } from 'src/styles/styles';

import * as customStyled from './styles';

interface VerticalSkeletonLoaderProps {
  type: 'reco' | 'similarContent';
}

const VerticalSkeletonLoader: React.FC<VerticalSkeletonLoaderProps> = ({
  type = 'similarContent'
}) => {
  return (
    <div
      className={type !== 'reco' ? 'keen-slider__slide' : ''}
      css={customStyled.skeletonWrapper(type)}>
      <div css={customStyled.skeletonCard}>
        <figure css={placeHolderRatio2X3}>
          <div css={customStyled.skeletonContent} />
        </figure>
      </div>
    </div>
  );
};

export default VerticalSkeletonLoader;
